import moment from "moment";
import React, { Component } from "react";
import FinanceServices from "../../services/axiosServices/apiServices/FinanceServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { saveAs } from "file-saver";
import PageLoader from "../../components/common/pageLoader/PageLoader";
import Selector from "../../components/dropdown/commonDropdown/Selector";
import { CommonValidationMessages } from "../../utils/Messages";
import { isValidForm, validate } from "../../utils/validation/CommonValidator";
import ValidationText from "../../utils/validation/ValidationText";
import Table from "../../components/table/Table";

export default class MemberYearTwoReport extends Component {
    constructor(props) {
        super(props);
        this.financeServices = new FinanceServices();
        this.swalServices = new SwalServices();
        this.state = {
            options: [
                {
                    value: 1,
                    label: "Event",
                },
                {
                    value: 2,
                    label: "Membership",
                },
                {
                    value: 3,
                    label: "External Invoice",
                }
            ],
            transactionRecordList: [],
            transactionRecordRequest: {
                startDate: '',
                endDate: '',
                transactionReportFor: 'Membership',
                isForDownloadRecords: true
            },
            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "CreatedAt",
                orderFlag: 0,
                searchText: "",
            },
            isLoading: false,
            totalCount: 0,
            totalResultes: 0,
            previousReportFor: "",
            previousReportStartDate: "",
            previousReportEndDate: "",
            validState: {
                isValid: true,
                error: {},
            },
            validationRule: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "Start date for transaction report"),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "End date for transaction report"),
                    },
                    {
                        type: "minEndDate",
                        minEndDate: "startDate",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "greater end date")
                    }
                ],
                transactionReportFor: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "type of transaction report"),
                    },
                ],
            },
        };
    }





    handleChange = (event) => {
        let name = event.target.name;
        let value = event.target.value;
        let transactionRecordRequestDetail = this.state.transactionRecordRequest;
        transactionRecordRequestDetail[name] = value;
        this.setState({ transactionRecordRequest: transactionRecordRequestDetail });
    }

    getSecondYearReportList = (pagination = this.state.pagination) => {


        pagination.startDate = this.state.transactionRecordRequest.startDate;
        pagination.endDate = this.state.transactionRecordRequest.endDate;
        pagination.transactionReportFor = this.state.transactionRecordRequest.transactionReportFor;
        pagination.isForDownloadRecords = this.state.transactionRecordRequest.isForDownloadRecords;

        if(pagination.startDate===''){
            this.swalServices.Error("Please Select Start Date");
            return


        }
        else if (pagination.endDate===''){
            this.swalServices.Error("Please Select End Date");
            return
        }
        else if (pagination) {
            this.financeServices
                .getSecondYearReportList(pagination)
                .then((response) => {
                    if (response.statusCode === 200 && response != null) {
                        var data = []
                        let totalCount
                        data = response.responseItem.responseContent.itemList
                        data = data.map(item => ({
                            ...item,
                            paymentDate: item.paymentDate ?  moment(item.paymentDate).format("DD MMM YYYY"): '',
                            invoiceDate: item.invoiceDate ?  moment(item.invoiceDate).format("DD MMM YYYY"): '',
                        }));
                        totalCount = response.responseItem.responseContent.totalCount

                        if(data && totalCount){
                            this.setState({ transactionRecordList: data, 
                                totalCount : totalCount,  
                                previousReportFor: this.state.transactionRecordRequest.transactionReportFor,
                                previousReportStartDate: this.state.transactionRecordRequest.startDate,
                                previousReportEndDate: this.state.transactionRecordRequest.endDate })
                            
                        }
                        else{
                            this.swalServices.Error("Data not found");
                        }

                    } else {
                    }
                });
        }
    }


    setPagination = (newPagination) => {
        newPagination.startDate = this.state.transactionRecordRequest.startDate;
        newPagination.endDate = this.state.transactionRecordRequest.endDate;
        newPagination.transactionReportFor = this.state.transactionRecordRequest.transactionReportFor;
        newPagination.isForDownloadRecords = this.state.transactionRecordRequest.isForDownloadRecords;

        if(newPagination){
            this.setState({ pagination: newPagination },()=>{
                this.getSecondYearReportList()

            });
        }

    };

    downloadSheet = ()=>{


        if (this.state.transactionRecordRequest.startDate && this.state.transactionRecordRequest.endDate) {
            let request = { ...this.state.pagination };
            request.startDate = moment(this.state.transactionRecordRequest.startDate).format("DD MMM YYYY");
            request.endDate = moment(this.state.transactionRecordRequest.endDate).format("DD MMM YYYY");
            request.transactionReportFor = this.state.transactionRecordRequest.transactionReportFor;
            this.financeServices.downloadSheetForSecondYearReport(request).then((response) => {
                if (response.status === 200 && response.data != null) {
                    this.setState({
                        previousReportFor: this.state.transactionRecordRequest.transactionReportFor,
                        previousReportStartDate: this.state.transactionRecordRequest.startDate,
                        previousReportEndDate: this.state.transactionRecordRequest.endDate
                    })
                    // let blob = new Blob([response.data])
                    // saveAs(blob, `${request.transactionReportFor}_TransactionReport.xlsx`);
                    let blob = new Blob([response.data]);
                    const startDate = moment(this.state.transactionRecordRequest.startDate).format("DD MMM YYYY");
                    const endDate = moment(this.state.transactionRecordRequest.endDate).format("DD MMM YYYY");
    
                    const fileName = `Year2_Member_Report (${startDate} - ${endDate}).xlsx`;
                    saveAs(blob, fileName);
                }
                else {
                    this.swalServices.Error(response.message);
                }
                this.setState({ isLoading: false });
            });
        }


    }




    render() {

        return (
            <div className="main-body-section finance-body-sec">
                <div className="bg-white">
                    <div className="grid grid-cols-12 gap-6 w-full items-center px-8 py-10">
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                Start Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="startDate"
                                    name="startDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(this.state.transactionRecordRequest.startDate).format("yyyy-MM-DD")}
                                    onChange={(event) => this.handleChange(event)}
                                // onBlur={() => this.validateField("startDate")}
                                />
                            </div>
                            <ValidationText error={this.state.validState.error.startDate} />
                        </div>
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                End Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="endDate"
                                    name="endDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(this.state.transactionRecordRequest.endDate).format("yyyy-MM-DD")}
                                    onChange={(event) => this.handleChange(event)}
                                // onBlur={() => this.validateField("endDate")}
                                // min={this.state.transactionRecordRequest.startDate}
                                />
                            </div>
                            <ValidationText error={this.state.validState.error.endDate} />
                        </div>


                        <div className="col-span-4">
                            <button className="btn btn-red text-xl border text-white mt-8" onClick={() => this.getSecondYearReportList()}>
                                Show Members Report
                            </button>
                        </div>
                        {this.state.transactionRecordList &&
                            this.state.transactionRecordList.length > 0 &&
                            this.state.previousReportFor === this.state.transactionRecordRequest.transactionReportFor &&
                            this.state.previousReportStartDate === this.state.transactionRecordRequest.startDate &&
                            this.state.previousReportEndDate === this.state.transactionRecordRequest.endDate ?
                            <div className="col-span-4">
                                <button className="btn btn-red text-xl border text-white mt-8" onClick={() => this.downloadSheet()}>
                                    Download Excel
                                </button>
                            </div>
                            : null}
                    </div>
                    <div className="grid grid-cols-12 gap-6 w-full items-center justify-center px-8 py-10">
                        <div className="2xl:col-span-12 lg:col-span-12 col-span-12 w-full">
                            {this.state.isLoading ? <PageLoader /> :
                                <Table
                                    columns={[
                                        { name: "CompanyName", title: "Company Name", },
                                        { name: "InvoiceDate", title: "Subscription End Date" },
                                        { name: "InvoiceNo", title: "Invoice No" },
                                        { name: "PaymentStatus", title: "Payment Status" },
                                        { name: "PaymentDate", title: "Payment Date" }


                                    ]}
                                    pagination={this.state.pagination}
                                    rows={this.state.transactionRecordList}
                                    sortingColumns={[""]}
                                    isLoading={this.state.isLoading}
                                    totalResultes={this.state.totalCount}
                                    totalCount={this.state.totalCount}
                                    setPagination={this.setPagination.bind(this)}
                                />}
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}
